<template>
  <div class="owner-fee-history-container animated fadeInRight">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('ownerFeeHistory.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input
            v-model="searchForm.link"
            :placeholder="$t('ownerFeeHistory.inputPhone')"
            clearable
            size="small"
          />
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="searchForm.name"
            :placeholder="$t('ownerFeeHistory.inputName')"
            clearable
            size="small"
          />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" size="small" @click="searchOwners" :loading="searchLoading">
            {{ $t('ownerFeeHistory.query') }}
          </el-button>
          <el-button size="small" @click="resetSearch">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 业主列表 -->
    <el-card class="mt-20">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('ownerFeeHistory.ownerList') }}</span>
      </div>
      <el-table :data="ownerList" border stripe style="width: 100%">
        <el-table-column prop="name" :label="$t('ownerFeeHistory.ownerName')" align="center" />
        <el-table-column prop="link" :label="$t('ownerFeeHistory.ownerPhone')" align="center" />
        <el-table-column prop="personRoleName" :label="$t('ownerFeeHistory.role')" align="center" />
        <el-table-column prop="remark" :label="$t('ownerFeeHistory.remark')" align="center" />
        <el-table-column :label="$t('ownerFeeHistory.action')" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewFeeDetail(scope.row)">
              {{ $t('ownerFeeHistory.feeTotal') }}
            </el-button>
            <el-button type="text" size="small" @click="viewFeeRecords(scope.row)">
              {{ $t('ownerFeeHistory.feeRecord') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!ownerList.length && !searchLoading" class="empty-text">
        {{ $t('ownerFeeHistory.noOwnerData') }}
      </div>
      <el-pagination
        @current-change="handleOwnerPageChange"
        @size-change="handleOwnerSizeChange"
        :current-page="ownerPage"
        :page-size="ownerPageSize"
        :page-sizes="[5, 10, 20, 50]"
        layout="total, sizes, prev, pager, next"
        :total="ownerTotal"
        style="text-align: right; margin-top: 15px;"
      />
    </el-card>

    <!-- 缴费历史月份弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      center
    >
      <el-table :data="monthSummary" border stripe style="width: 100%" v-loading="summaryLoading">
        <el-table-column prop="month" :label="$t('ownerFeeHistory.month')" align="center" />
        <el-table-column prop="count" :label="$t('ownerFeeHistory.count')" align="center" />
        <el-table-column prop="receivableAmount" :label="$t('ownerFeeHistory.receivableAmount')" align="center" />
        <el-table-column prop="receivedAmount" :label="$t('ownerFeeHistory.receivedAmount')" align="center" />
      </el-table>
      <el-pagination
        @current-change="handleMonthPageChange"
        @size-change="handleMonthSizeChange"
        :current-page="monthPage"
        :page-size="monthPageSize"
        :page-sizes="[5, 10, 20]"
        layout="total, sizes, prev, pager, next"
        :total="monthTotal"
        style="text-align: right; margin-top: 15px;"
      />
    </el-dialog>

    <!-- 缴费记录弹窗 -->
    <el-dialog
      :title="feeRecordTitle"
      :visible.sync="feeRecordVisible"
      width="70%"
      center
    >
      <el-table :data="feeRecordList" border stripe style="width: 100%" v-loading="feeRecordLoading">
        <el-table-column prop="feeName" :label="$t('ownerFeeHistory.feeItem')" align="center" />
        <el-table-column :label="$t('ownerFeeHistory.billingMonth')" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime ? scope.row.startTime.substring(0, 7) : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="cycles" :label="$t('ownerFeeHistory.cycle')" align="center" />
        <el-table-column :label="$t('ownerFeeHistory.receivableAmount')" align="center">
          <template slot-scope="scope">
            {{ scope.row.receivableAmount }}/{{ scope.row.receivedAmount }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('ownerFeeHistory.payPeriod')" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime }}~{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('ownerFeeHistory.payTime')" align="center" />
        <el-table-column prop="stateName" :label="$t('ownerFeeHistory.status')" align="center" />
      </el-table>
      <el-pagination
        @current-change="handleFeeRecordPageChange"
        @size-change="handleFeeRecordSizeChange"
        :current-page="feeRecordPage"
        :page-size="feeRecordPageSize"
        :page-sizes="[5, 10, 20, 50]"
        layout="total, sizes, prev, pager, next"
        :total="feeRecordTotal"
        style="text-align: right; margin-top: 15px;"
      />
    </el-dialog>
  </div>
</template>

<script>
import { queryOwners } from '@/api/owner/ownerApi'
import { queryFeeDetailSummary, queryFeeDetail } from '@/api/fee/simplifyHisFeeApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'OwnerFeeHistory',
  data() {
    return {
      communityId: '',
      searchForm: {
        link: '',
        name: ''
      },
      searchLoading: false,
      ownerList: [],
      ownerPage: 1,
      ownerPageSize: 10,
      ownerTotal: 0,
      dialogVisible: false,
      dialogTitle: '',
      monthSummary: [],
      monthPage: 1,
      monthPageSize: 10,
      monthTotal: 0,
      summaryLoading: false,
      feeRecordVisible: false,
      feeRecordTitle: '',
      feeRecordList: [],
      feeRecordLoading: false,
      feeRecordPage: 1,
      feeRecordPageSize: 10,
      feeRecordTotal: 0,
      selectedOwner: {}
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.searchOwners()
  },
  methods: {
    async searchOwners() {
      this.searchLoading = true
      this.ownerPage = 1
      this.ownerList = []
      try {
        const { link, name } = this.searchForm
        const params = { page: this.ownerPage, row: this.ownerPageSize }
        if (link) params.link = link
        if (name) params.name = name
        const res = await queryOwners(params)
        this.ownerList = res.data || []
        this.ownerTotal = res.total || 0
      } catch (error) {
        this.$message.error(error.message || this.$t('common.fetchError'))
      } finally {
        this.searchLoading = false
      }
    },
    handleOwnerPageChange(page) {
      this.ownerPage = page
      this._fetchOwnerList()
    },
    handleOwnerSizeChange(size) {
      this.ownerPageSize = size
      this.ownerPage = 1
      this._fetchOwnerList()
    },
    async _fetchOwnerList() {
      this.searchLoading = true
      this.ownerList = []
      try {
        const { link, name } = this.searchForm
        const params = { page: this.ownerPage, row: this.ownerPageSize }
        if (link) params.link = link
        if (name) params.name = name
        const res = await queryOwners(params)
        this.ownerList = res.data || []
        this.ownerTotal = res.total || 0
      } catch (error) {
        this.$message.error(error.message || this.$t('common.fetchError'))
      } finally {
        this.searchLoading = false
      }
    },
    resetSearch() {
      this.searchForm = { link: '', name: '' }
      this.ownerList = []
      this.monthSummary = []
    },
    async viewFeeDetail(owner) {
      this.selectedOwner = owner
      this.monthPage = 1
      this.dialogTitle = this.$t('ownerFeeHistory.monthSummary') + '（' + owner.name + ' ' + owner.link + '）'
      this.dialogVisible = true
      this._fetchMonthSummary()
    },
    async _fetchMonthSummary() {
      this.summaryLoading = true
      this.monthSummary = []
      try {
        const params = {
          communityId: this.communityId,
          ownerId: this.selectedOwner.ownerId,
          page: this.monthPage,
          row: this.monthPageSize
        }
        const res = await queryFeeDetailSummary(params)
        this.monthSummary = res.data.data || []
        this.monthTotal = res.data.total || 0
      } catch (error) {
        this.$message.error(error.message || this.$t('common.fetchError'))
      } finally {
        this.summaryLoading = false
      }
    },
    handleMonthPageChange(page) {
      this.monthPage = page
      this._fetchMonthSummary()
    },
    handleMonthSizeChange(size) {
      this.monthPageSize = size
      this.monthPage = 1
      this._fetchMonthSummary()
    },
    async viewFeeRecords(owner) {
      this.selectedOwner = owner
      this.feeRecordPage = 1
      this.feeRecordTitle = this.$t('ownerFeeHistory.feeRecordTitle') + '（' + owner.name + ' ' + owner.link + '）'
      this.feeRecordVisible = true
      this._fetchFeeRecords()
    },
    async _fetchFeeRecords() {
      this.feeRecordLoading = true
      this.feeRecordList = []
      try {
        const res = await queryFeeDetail({
          page: this.feeRecordPage,
          row: this.feeRecordPageSize,
          communityId: this.communityId,
          ownerId: this.selectedOwner.ownerId
        })
        const data = res.data
        this.feeRecordList = data.feeDetails || []
        this.feeRecordTotal = data.total || 0
      } catch (error) {
        this.$message.error(error.message || this.$t('common.fetchError'))
      } finally {
        this.feeRecordLoading = false
      }
    },
    handleFeeRecordPageChange(page) {
      this.feeRecordPage = page
      this._fetchFeeRecords()
    },
    handleFeeRecordSizeChange(size) {
      this.feeRecordPageSize = size
      this.feeRecordPage = 1
      this._fetchFeeRecords()
    }
  }
}
</script>

<style scoped>
.owner-fee-history-container {
  padding: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.empty-text {
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 30px 0;
}
</style>
